import { render, staticRenderFns } from "./BusinessClientNav.vue?vue&type=template&id=437c15bf&scoped=true&"
import script from "./BusinessClientNav.vue?vue&type=script&lang=ts&"
export * from "./BusinessClientNav.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessClientNav.vue?vue&type=style&index=0&id=437c15bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437c15bf",
  null
  
)

export default component.exports